import React from 'react';

const css = `
  @media (max-width: 768px) {
    /* Stack the photo above the bio and bring the oversized type back to a
       readable size for a phone. */
    .about-section {
      padding: 80px 20px !important;
      grid-template-columns: 1fr !important;
      gap: 44px !important;
    }
    .about-image {
      width: 100% !important;
      max-width: 300px !important;
      margin: 0 auto !important;
    }
    .about-label {
      font-size: 0.75rem !important;
      letter-spacing: 0.35em !important;
      margin-bottom: 16px !important;
    }
    .about-body {
      font-size: 1.02rem !important;
      line-height: 1.75 !important;
      margin-bottom: 16px !important;
    }
  }
`;

// Optional bio photo. Set to a path like '/images/gallery/photo-6.jpg' to use
// one of your portfolio images here instead of the placeholder frame.
const aboutImage = '/images/about.jpg';

const styles = {
  section: {
    padding: '120px 60px',
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '80px',
    alignItems: 'center',
    maxWidth: '1200px',
    margin: '0 auto',
  },
  label: {
    fontFamily: "'Outfit', sans-serif",
    fontSize: '2rem',
    letterSpacing: '0.35em',
    textTransform: 'uppercase',
    color: '#c9a96e',
    marginBottom: '24px',
    display: 'block',
  },
  body: {
    fontFamily: "'Outfit', sans-serif",
    fontSize: '1.5rem',
    fontWeight: 300,
    lineHeight: 1.9,
    color: '#8a8580',
    marginBottom: '20px',
  },
  imagePlaceholder: {
    aspectRatio: '3/4',
    background: 'linear-gradient(160deg, #1a1510, #0f0d0a)',
    border: '1px solid rgba(201,169,110,0.15)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    overflow: 'hidden',
  },
  imagePlaceholderText: {
    fontFamily: "'Cormorant Garamond', serif",
    fontStyle: 'italic',
    fontSize: '1rem',
    color: '#3a3530',
    letterSpacing: '0.1em',
  },
  corner: {
    position: 'absolute',
    width: '20px',
    height: '20px',
    borderColor: '#c9a96e',
    borderStyle: 'solid',
    borderWidth: 0,
    opacity: 0.4,
  },
};

export default function About() {
  return (
    <>
      <style>{css}</style>
      <section id="about" style={{ padding: '120px 0' }}>
        <div className="about-section" style={styles.section}>
          {/* Image */}
          <div className="about-image" style={styles.imagePlaceholder}>
            {aboutImage ? (
              <img
                src={aboutImage}
                alt="Noah Sato"
                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
              />
            ) : (
              <span style={styles.imagePlaceholderText}>Your Headshot</span>
            )}
            {/* Corner accents */}
            <div style={{ ...styles.corner, top: 16, left: 16, borderTopWidth: 1, borderLeftWidth: 1 }} />
            <div style={{ ...styles.corner, top: 16, right: 16, borderTopWidth: 1, borderRightWidth: 1 }} />
            <div style={{ ...styles.corner, bottom: 16, left: 16, borderBottomWidth: 1, borderLeftWidth: 1 }} />
            <div style={{ ...styles.corner, bottom: 16, right: 16, borderBottomWidth: 1, borderRightWidth: 1 }} />
          </div>

          {/* Text */}
          <div>
            <span className="about-label" style={styles.label}>Background</span>
            <p className="about-body" style={styles.body}>
              A versatile performer with a passion for authentic, character-driven storytelling. What began as a love for film evolved into a desire for experience, learning by doing, studying, and observation. Bringing raw authenticity to the forefront of every role.
            </p>
            <p className="about-body" style={styles.body}>
              Noah Sato is an Austin, TX based performer, who looks to showcase his talents through film, and voice work.
            </p>
          </div>
        </div>
      </section>
    </>
  );
}
